import { useMutation } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

export function useSetAccountEnabled(accountId: string) {
  return useMutation({
    mutationFn: (enabled: boolean) => UsersService.setAccountEnabled(accountId, enabled),
  });
}
